import { useContext } from 'react';
import { RedirectContext } from '../context/RedirectContext';

export function useRedirect() {
  const context = useContext(RedirectContext);
  if (!context) {
    throw new Error('useRedirect must be used within RedirectProvider');
  }
  return context;
}
